import {
    PARTICIPANT_HAVE_ROLE_LIST,
    PARTICIPANT_NO_ROLE_LIST,
    PARTICIPANT_ERROR,
    PARTICIPANT_REMOVE,
    PARTICIPANT_PENDING,
    PARTICIPANT_PENDING_DONE,
    PARTICIPANT_UPDATE,
    PARTICIPANT_ADD,
} from "../action-types/participant"

const initParticipants = {
    loading: true,
    pending: false,
    successStatus: false,
    participants: {
        haveRole: [],
        noRole: [],
    },
    message: "",
    messagePopup: false,
    mainPageError: false,
}
export default function participantReducer(state = initParticipants, action) {
    switch (action.type) {
        case PARTICIPANT_PENDING: {
            return {
                ...state,
                pending: true,
            }
        }
        case PARTICIPANT_PENDING_DONE: {
            return {
                ...state,
                messagePopup: false,
            }
        }
        case PARTICIPANT_ADD: {
            const { messagePopup } = action.payload
            let messagePopupShow = true
            if (messagePopup != null) {
                messagePopupShow = messagePopup
            }
            return {
                ...state,
                participants: { ...state.participants, noRole: [...state.participants.noRole, action.payload.participant] },
                messagePopup: messagePopupShow,
                message: "Add success",
                successStatus: true,
            }
        }
        case PARTICIPANT_UPDATE: {
            const { noRoleStatus } = action.payload
            const selectedParticipant = action.payload.participant
            if (noRoleStatus) {
                // pick noRole
                return {
                    ...state,
                    messagePopup: true,
                    successStatus: true,
                    message: "Update Success",
                    participants: {
                        ...state.participants,
                        noRole: state.participants.noRole.map((participant) => {
                            return participant.participantId === selectedParticipant.participantId
                                ? {
                                      ...selectedParticipant,
                                      responseCount: participant.responseCount,
                                      questionCount: participant.responseCount,
                                  }
                                : participant
                        }),
                    },
                }
            }
            // pick haveRole
            return {
                ...state,
                messagePopup: true,
                successStatus: true,
                message: "Update Success",
                participants: {
                    ...state.participants,
                    haveRole: state.participants.haveRole.map((participant) => {
                        return participant.participantId === selectedParticipant.participantId
                            ? {
                                  ...selectedParticipant,
                                  responseCount: participant.responseCount,
                                  questionCount: participant.responseCount,
                              }
                            : participant
                    }),
                },
            }
        }
        case PARTICIPANT_REMOVE: {
            const { participantId, noRoleSet } = action.payload
            if (noRoleSet) {
                // delete no role participant
                return {
                    ...state,
                    loading: false,
                    successStatus: true,
                    pending: false,
                    participants: {
                        ...state.participants,
                        noRole: state.participants.noRole.filter((participant) => participant.participantId !== participantId),
                    },
                    messagePopup: true,
                    message: "delete success",
                }
            }
            return {
                ...state,
                loading: false,
                successStatus: true,
                pending: false,
                participants: {
                    ...state.participants,
                    haveRole: state.participants.haveRole.filter((participant) => participant.participantId !== participantId),
                },
                messagePopup: true,
            }
        }
        case PARTICIPANT_HAVE_ROLE_LIST: {
            return {
                ...state,
                loading: false,
                pending: false,
                successStatus: true,
                participants: {
                    ...state.participants,
                    haveRole: action.payload,
                },
                messagePopup: false,
            }
        }
        case PARTICIPANT_NO_ROLE_LIST: {
            return {
                ...state,
                loading: false,
                successStatus: true,
                pending: false,
                participants: {
                    ...state.participants,
                    noRole: action.payload,
                },
                messagePopup: false,
            }
        }
        case PARTICIPANT_ERROR: {
            return {
                ...state,
                loading: false,
                successStatus: false,
                messagePopup: true,
                message: action.payload.message,
                mainPageError: action.payload.mainPageError,
                pending: false,
            }
        }
        default:
            return state
    }
}
